var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 82,
    viewBox: "0 0 152 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82935 17.5C3.33374 17.5 0.5 20.3654 0.5 23.9C0.5 27.4346 3.33374 30.3 6.82935 30.3H42.997C39.5014 30.3 36.6677 33.1654 36.6677 36.7C36.6677 40.2346 39.5014 43.1 42.997 43.1H23.1048C19.6092 43.1 16.7755 45.9654 16.7755 49.5C16.7755 53.0346 19.6092 55.9 23.1048 55.9H32.304C36.7115 55.9 40.2844 58.7654 40.2844 62.3C40.2844 63.7829 39.5683 65.1774 38.136 66.4837C36.2116 68.2386 33.2539 68.3739 31.1522 69.912C29.5635 71.0747 28.5299 72.9653 28.5299 75.1C28.5299 78.6346 31.3637 81.5 34.8593 81.5H109.907C113.403 81.5 116.237 78.6346 116.237 75.1C116.237 71.5654 113.403 68.7 109.907 68.7H145.171C148.666 68.7 151.5 65.8346 151.5 62.3C151.5 58.7654 148.666 55.9 145.171 55.9H109.003C105.507 55.9 102.674 53.0346 102.674 49.5C102.674 45.9654 105.507 43.1 109.003 43.1H131.608C135.103 43.1 137.937 40.2346 137.937 36.7C137.937 33.1654 135.103 30.3 131.608 30.3H95.4401C98.9357 30.3 101.769 27.4346 101.769 23.9C101.769 20.3654 98.9357 17.5 95.4401 17.5H6.82935ZM6.82935 43.1C3.33374 43.1 0.5 45.9654 0.5 49.5C0.5 53.0346 3.33374 55.9 6.82935 55.9C10.3249 55.9 13.1587 53.0346 13.1587 49.5C13.1587 45.9654 10.3249 43.1 6.82935 43.1Z",
    fill: "#EFECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.968 12.4101L67.6767 1.30293C65.3894 0.859483 63.1757 2.35423 62.7322 4.64153L55.6397 41.225C55.1963 43.5123 56.691 45.726 58.9783 46.1695L116.269 57.2766C118.557 57.7201 120.77 56.2254 121.214 53.938L128.306 17.3545C128.75 15.0672 127.255 12.8535 124.968 12.4101Z",
    fill: "white",
    stroke: "#5C41FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5254 13.6206L126.607 26.238",
    stroke: "#5C41FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5918 32.3525L80.1898 35.3766",
    stroke: "#5C41FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4453 38.269L99.482 45.2556",
    stroke: "#5C41FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1846 24.325L37.0283 29.1712C34.7064 29.3646 32.9811 31.4037 33.1745 33.7256L36.2691 70.8615C36.4625 73.1834 38.5016 74.9088 40.8234 74.7153L98.9798 69.8692C101.302 69.6757 103.027 67.6366 102.834 65.3148L99.739 28.1788C99.5455 25.8569 97.5065 24.1316 95.1846 24.325Z",
    fill: "white",
    stroke: "#5C41FF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4492 42.6953L100.513 37.1903",
    stroke: "#5C41FF",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4785 59.8936L58.312 58.5742",
    stroke: "#5C41FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9805 65.8994L79.5614 62.8512",
    stroke: "#5C41FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPageIcon);
export default __webpack_public_path__ + "static/media/EmptyPageIcon.686bcb594092d8f59f5bb10cacced93e.svg";
export { ForwardRef as ReactComponent };